var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('carousel',{attrs:{"per-page":1,"pagination-padding":4,"value":_vm.selectedPage,"pagination-enabled":true,"pagination-active-color":"#4c7499"},on:{"pageChange":_vm.handlePageChange}},_vm._l((_vm.testimonials),function(testimonial){return _c('slide',{key:testimonial.Id},[_c('client-testimonial',{attrs:{"testimonial":testimonial}})],1)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-723af5c4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./WebResources/vue/grad-images/home/index/components/ContentItems/ClientTestimonialCarousel.vue
// module id = 1713
// module chunks = 10